import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { TypographySkeleton } from "@circleco/compass/components/TypographySkeleton";

interface PlanTrialCardSkeletonProps {
  isAttached?: boolean;
}

export const PlanTrialCardSkeleton = ({
  isAttached = false,
}: PlanTrialCardSkeletonProps) => (
  <div
    className={classNames(
      "bg-primary border-primary space-y-2 rounded-lg border p-4",
      isAttached && "rounded-none border-x-0 border-b-0 border-t",
    )}
  >
    <div className="flex items-center justify-between gap-4">
      <TypographySkeleton variant="label-md" className="w-2/3" />
      <TypographySkeleton variant="label-md" className="w-12" />
    </div>
    <TypographySkeleton variant="label-xs" />
  </div>
);
